// Thin shim that re-exports the official r180 addons STLLoader.
// STLLoader adds .stl 3D model support to YDBoxVolume (setRes id=4).
// Note: STLLoader.load returns a BufferGeometry (not an Object3D);
// the consumer must wrap it in a Mesh.
// See libs/three.js/examples/jsm/loaders/STLLoader.js for the actual implementation.
export { STLLoader } from '../../libs/three.js/examples/jsm/loaders/STLLoader.js';
